let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Acsm")).then(() => parcelRequire('6dsY7'));